// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "2895eb66d80d90acc7d37e7e5c247214c5c0dc87/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"2a222798","98":"c3469f9b","215":"28b12c6b","440":"486bdddc","496":"89e6df15","581":"a474c96c","731":"955d3fe5"}[chunkId] + ".chunk.js";
};